import http from "../../http";

const BATCH = "/resident/api/resident/houseBillBatch";
const BILL = "/resident/api/resident/houseBill";
const PAY = "/resident/api/resident/housePayment";

export const billBatch = {
  selectPage(r) {
    return http.get(`${BATCH}/page`, r);
  },
  selectById(r) {
    return http.get(`${BATCH}/detail`, r);
  },
  generate(r) {
    return http.payload(`${BATCH}/generate`, r);
  },
};

export const bill = {
  selectPage(r) {
    return http.get(`${BILL}/page`, r);
  },
  selectById(r) {
    return http.get(`${BILL}/detail`, r);
  },
};

export const payment = {
  selectPage(r) {
    return http.get(`${PAY}/page`, r);
  },
  selectById(r) {
    return http.get(`${PAY}/detail`, r);
  },
  adminPreviewPeriod(r) {
    return http.payload(`${PAY}/adminPreviewPeriod`, r);
  },
  adminCashCollect(r) {
    return http.payload(`${PAY}/adminCashCollect`, r);
  },
};

export default { billBatch, bill, payment };
